import { mount } from "svelte";
import App from "./App.svelte";
import "../css/style.css";
import "./styles/shell.css";

mount(App, {
  target: document.getElementById("app"),
});
